import React from 'react';
import { Form, reduxForm } from 'redux-form';
import Clear from '@material-ui/icons/Clear';

import { TextField, Button, Paper, Translation, Link } from '../../common';

import * as zipCodeStatuses from '../../../constants/zipCode';
import { LOGIN } from '../../../constants/routes';
import { DOMAIN_LANGUAGE, NL, DE } from '../../../constants/browser';

import { zipCode as zipCodeValidator } from '../../../utils/validation';

import { connectTo } from '../../../utils';

const ZipCodeErrorMessage = ({ styles }) => (
  <div className={styles['zip-code-form__error-wrapper']}>
    <Clear className={styles['zip-code-form__error-icon']} />
    <Translation className={styles['zip-code-form__error-text']}>
      ZIPCODE_VALIDATION_ERROR
    </Translation>
  </div>
);

const ZipCodeForm = reduxForm({ form: 'zip-code' })(
  ({
    handleSubmit,
    styles,
    translations,
    onSubmit,
    attemptsLeft,
    attemptsAllowed,
    invalid,
    pristine,
    invalidCode,
  }) => (
    <Form
      className={styles['zip-code-form__form']}
      onSubmit={handleSubmit((values) => onSubmit(values['zip-code']))}
    >
      <Translation className={styles['zip-code-form__description']}>
        ZIPCODE_VALIDATION_INFO
      </Translation>
      <TextField
        name="zip-code"
        inputMode="numeric"
        pattern="[0-9-]*"
        label={`${
          translations['ZIPCODE_VALIDATION_ATTEMPT'] || ''
        } ${attemptsLeft}/${attemptsAllowed}:`}
        className={styles['zip-code-form__form-text-field']}
        validate={zipCodeValidator}
      />
      {invalidCode ? <ZipCodeErrorMessage styles={styles} /> : null}
      <Button
        id="page.zip-code.component.zip-code-form.zip-code-submit-button"
        disabled={invalid || pristine}
        type="submit"
        className={styles['zip-code-form__form-button']}
      >
        <Translation>ZIPCODE_VALIDATION_SUBMIT</Translation>
      </Button>
    </Form>
  )
);

const CALL_SERVICE_PHONES = {
  [DE]: '+4929417463012',
  [NL]: '+31514788109',
};

const ZipCode = ({
  styles,
  translations,
  LogoComponent: Logo,
  status,
  onSubmit,
  attemptsAllowed,
  attemptsLeft,
}) => (
  <Paper className={styles['zip-code-form__wrapper']}>
    <div className={styles['zip-code-form__content']}>
      <Logo />
      {status === zipCodeStatuses.ASK_FOR_ZIP_CODE_STATUS ||
      status === zipCodeStatuses.INCORRECT_ZIP_CODE_STATUS ? (
        <ZipCodeForm
          invalidCode={status === zipCodeStatuses.INCORRECT_ZIP_CODE_STATUS}
          {...{ styles, onSubmit, translations, attemptsAllowed, attemptsLeft }}
        />
      ) : (
        <div className={styles['zip-code-form__blocked']}>
          {status === zipCodeStatuses.NO_ATTEPMTS_LEFT_STATUS ? (
            <ZipCodeErrorMessage styles={styles} />
          ) : null}
          <Translation className={styles['zip-code-form__blocked-error']}>
            {status === zipCodeStatuses.NO_ATTEPMTS_LEFT_STATUS
              ? 'ZIPCODE_VALIDATION_NO_ATTEMPTS_LEFT'
              : 'ZIPCODE_VALIDATION_BLOCKED'}
          </Translation>
          <div className={styles['zip-code-form__blocked-controls']}>
            <Link
              className={styles['zip-code-form__blocked-controls-link']}
              id="page.zip-code.component.zip-code-error.redirect-to-login-link"
              to={LOGIN}
            >
              <Button
                id="page.zip-code.component.zip-code-error.redirect-to-login-button"
                className={styles['zip-code-form__blocked-controls-redirect']}
                fullWidth
              >
                <Translation>ZIPCODE_VALIDATION_LOGIN_REDIRECT</Translation>
              </Button>
            </Link>
            <Link
              raw
              className={styles['zip-code-form__blocked-controls-link']}
              id="page.zip-code.component.zip-code-error.call-service-link"
              to={`tel:${CALL_SERVICE_PHONES[DOMAIN_LANGUAGE] || ''}`}
            >
              <Button
                id="page.zip-code.component.zip-code-error.call-service-button"
                className={styles['zip-code-form__blocked-controls-call']}
                fullWidth
              >
                <Translation>ZIPCODE_VALIDATION_CALL_SERVICE</Translation>
              </Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  </Paper>
);

export default connectTo(
  ({ translations: { translations } }) => ({ translations }),
  {},
  ZipCode
);
